/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeweblabel2Inputs */

const en_placeweblabel2 = /** @type {(inputs: Placeweblabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website of your place`)
};

const de_placeweblabel2 = /** @type {(inputs: Placeweblabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website deines Orts`)
};

/**
* | output |
* | --- |
* | "Website of your place" |
*
* @param {Placeweblabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeweblabel2 = /** @type {((inputs?: Placeweblabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeweblabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeweblabel2(inputs)
	return de_placeweblabel2(inputs)
});
export { placeweblabel2 as "placeWebLabel" }